import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { tienePermiso } from '../utils/permisosHelper';

const PrivateRoute = ({ children, requiredPermission, requiredPermissions, message }) => {
  const { usuario, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Cargando...</div>
      </div>
    );
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  // Verificar permiso único
  if (requiredPermission && !tienePermiso(usuario, requiredPermission)) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>🔒</div>
        <h2 style={{ marginBottom: '10px', color: '#f44336' }}>Acceso Denegado</h2>
        <p style={{ color: '#666', maxWidth: '500px' }}>
          {message || 'No tienes los permisos necesarios para acceder a esta sección.'}
        </p>
        <p style={{ color: '#999', fontSize: '14px', marginTop: '10px' }}>
          Rol actual: <strong>{usuario.rol?.nombre || 'Sin rol'}</strong>
        </p>
      </div>
    );
  }

  // Verificar múltiples permisos (debe tener al menos uno)
  if (requiredPermissions && Array.isArray(requiredPermissions)) {
    const tieneAlgunPermiso = requiredPermissions.some(perm => 
      tienePermiso(usuario, perm)
    );

    if (!tieneAlgunPermiso) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          textAlign: 'center',
          padding: '20px'
        }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>🔒</div>
          <h2 style={{ marginBottom: '10px', color: '#f44336' }}>Acceso Denegado</h2>
          <p style={{ color: '#666', maxWidth: '500px' }}>
            {message || 'No tienes los permisos necesarios para acceder a esta sección.'}
          </p>
          <p style={{ color: '#999', fontSize: '14px', marginTop: '10px' }}>
            Rol actual: <strong>{usuario.rol?.nombre || 'Sin rol'}</strong>
          </p>
        </div>
      );
    }
  }

  return children;
};

export default PrivateRoute;